// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3pD6K","ranges":"BmiRanges_ranges__22fV6"};